export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-teal-600 via-teal-700 to-orange-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center bg-white rounded-lg">
                <i className="ri-trophy-line text-teal-600 text-2xl"></i>
              </div>
              <span className="text-2xl font-bold">Revenant League</span>
            </div>
            <p className="text-white/80 text-sm leading-relaxed">
              The ultimate competitive gaming platform for tournaments, training, and community engagement.
            </p>
          </div>

          {/* Tournaments */}
          <div>
            <h3 className="font-bold text-lg mb-4">Tournaments</h3>
            <ul className="space-y-2.5">
              <li>
                <a href="/tournaments" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Weekly Clash
                </a>
              </li>
              <li>
                <a href="/tournaments" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Monthly Championship
                </a>
              </li>
              <li>
                <a href="/tournaments" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Season Rankings
                </a>
              </li>
            </ul>
          </div>

          {/* Training */}
          <div>
            <h3 className="font-bold text-lg mb-4">Training</h3>
            <ul className="space-y-2.5">
              <li>
                <a href="/training" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Coaching Programs
                </a>
              </li>
              <li>
                <a href="/training" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Skill Development
                </a>
              </li>
              <li>
                <a href="/training" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Training Resources
                </a>
              </li>
            </ul>
          </div>

          {/* Community */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Platform</h3>
            <ul className="space-y-3">
              <li>
                <a href="/training" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Training
                </a>
              </li>
              <li>
                <a href="/tournaments" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Tournaments
                </a>
              </li>
              <li>
                <a href="/clips" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Clips
                </a>
              </li>
              <li>
                <a href="/streams" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Streams
                </a>
              </li>
              <li>
                <a href="/leaderboard" className="text-white/80 hover:text-white transition-colors cursor-pointer">
                  Leaderboard
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/70 text-sm">
            © 2024 Revenant League. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-white/70 hover:text-white transition-colors cursor-pointer">
              <i className="ri-twitter-x-line text-xl"></i>
            </a>
            <a href="https://discord.gg/fqczEGYf" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors cursor-pointer">
              <i className="ri-discord-line text-xl"></i>
            </a>
            <a href="#" className="text-white/70 hover:text-white transition-colors cursor-pointer">
              <i className="ri-youtube-line text-xl"></i>
            </a>
            <a href="#" className="text-white/70 hover:text-white transition-colors cursor-pointer">
              <i className="ri-twitch-line text-xl"></i>
            </a>
          </div>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-white/70 hover:text-white transition-colors text-sm cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
